import styled from "styled-components";

export const SelectDropdownWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
`;

export const StyledSelect = styled.select`
    width: 100%;
    height: fit-content;
    color: var(--text-color-primary);
    font-size: 16px;
    text-transform: capitalize;
    border: 1px solid var(--border-color);
    outline: 1px solid transparent;
    border-radius: 10px;
    background-color: var(--theme-color-secondary);
    padding: 14px 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all ease-in-out 0.3s;

    &::placeholder {
        color: var(--text-color-secondary);
        opacity: 0.6;
        font-size: 14px;
    }

    &:focus {
        border-color: var(--theme-color-primary);
        outline-color: var(--theme-color-primary);
    }

    &:disabled {
        cursor: not-allowed;
        color: var(--text-color-secondary);
    }
`;